import { Component, OnInit } from '@angular/core'
import { ApiService, UserInfo } from '../../../services/api.service'
import { environment } from '../../../../environments/environment'
import { ButtonComponent } from '@components/button/button.component'
import { CommonModule } from '@angular/common'
import { TranslateModule } from '@ngx-translate/core'

@Component({
    selector: 'app-virtual-visit-banner',
    templateUrl: './virtual-visit-banner.component.html',
    imports: [ButtonComponent, CommonModule, TranslateModule],
    standalone: true,
    // styleUrl: './home.component.scss',
})
export class VirtualVisitBanner implements OnInit {
    userInfo: UserInfo
    protected readonly environment = environment

    constructor(private api: ApiService) {}

    ngOnInit(): void {
        this.api.userInfo.subscribe((userInfo) => (this.userInfo = userInfo))
    }
    b64(str: string | null | undefined): string {
        if(!str) return ''
        return btoa(unescape(encodeURIComponent(str)))
    }

    goToVirtualVisit() {
        const accountName = this.userInfo.accountName
        const firstName = this.userInfo.firstName
        const phone = this.userInfo.accountPhone
        const email = this.userInfo.email
        const contactId = this.userInfo.salesforceContactId

        const url = `https://www.cosentino.com/landings-usa/appointment/?accountName=${this.b64(accountName)}&firstName=${this.b64(firstName)}&phone=${this.b64(
            phone
        )}&email=${this.b64(email)}&contactId=${contactId}`
        
        window.open(url, '_blank')
    }
}
